import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-quill/dist/quill.snow.css';
import App from './App';
import { InternationalizationProvider } from './contexts';
import { AuthProvider } from './hooks/useAuth';
import { SettingsProvider } from './hooks/useSettings';
import './i18n';
import './chart';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './schemas/init.ts';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <InternationalizationProvider>
    <AuthProvider>
      <SettingsProvider>
        <React.Suspense fallback="">
          <App />
        </React.Suspense>
      </SettingsProvider>
    </AuthProvider>
  </InternationalizationProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
